
export class DropdownComponent {
   
    public statusTypes: Array<{ statusTypeName: string, displayActiveStatus: any }> = [
        { statusTypeName: "Active", displayActiveStatus: "Active" },
        { statusTypeName: "Inactive", displayActiveStatus: "Inactive" }
    ];

}
